import helpers from '../helpers';

const pageUrl = `${helpers.path}site.html`;

const loadSite = () => {
	return fetch(pageUrl)
		.then((response) => response.text())
		.then((html) => {
			const parser = new DOMParser();
			const page = parser.parseFromString(html, 'text/html');

			document.querySelector('.site').innerHTML = page.querySelector('.site').innerHTML;
		})
		.catch((error) => console.log(error)); // eslint-disable-line no-console
};

export {loadSite};
